import {
    CreateExternalEventEventLocationVisibilityDocument,
    DeleteExternalEventLocationVisibilityDocument,
    ExternalEventLocationVisibility,
    GetExternalEventDefaultLocationsDocument,
} from '@/generated/graphql';
import { useApolloClient, useMutation } from '@vue/apollo-composable';

export function useExternalEventVisibilities() {
    const createVisibilityMutation = useMutation(CreateExternalEventEventLocationVisibilityDocument);
    const deleteVisibilityMutation = useMutation(DeleteExternalEventLocationVisibilityDocument);
    const { client } = useApolloClient();

    async function createDefaultVisibilities(eventId: string, locationIds: string[]) {
        for (const locationId of locationIds) {
            const result = await createVisibilityMutation.mutate({
                eventId,
                locationId,
                visibility: ExternalEventLocationVisibility.Full,
            });
            if (result?.errors) {
                return false;
            }
        }
        return true;
    }

    async function createDefaultVisibilitiesForFederalStates(eventId: string) {
        const locations = await client.query({ query: GetExternalEventDefaultLocationsDocument });
        const locationIds = locations.data.externalEventLocations?.nodes.map((n) => n.id);
        if (!locationIds) {
            throw Error('Could not retreive default locations on createDefaultVisibilitiesForFederalStates');
        }
        createDefaultVisibilities(eventId, locationIds);
    }

    async function deleteDefaultVisibilitiesForFederalStates(eventId: string) {
        const locations = await client.query({ query: GetExternalEventDefaultLocationsDocument });
        const locationIds = locations.data.externalEventLocations?.nodes.map((n) => n.id);
        if (!locationIds) {
            throw Error('Could not retreive default locations on deleteDefaultVisibilitiesForFederalStates');
        }
        for (const id of locationIds) {
            await deleteVisibilityMutation.mutate({ eventId, locationId: id });
        }
    }

    return {
        createDefaultVisibilities,
        createDefaultVisibilitiesForFederalStates,
        deleteDefaultVisibilitiesForFederalStates,
    };
}
